import { Bell } from "lucide-react";
import type React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { InstantNotificationTab } from "@/features/user-setting/components/InstantNotificationTab";
import { PeriodicNotificationTab } from "@/features/user-setting/components/PeriodicNotificationTab";
import { SettingsModalLayout } from "@/features/user-setting/components/SettingsModalLayout";

interface EmailNotificationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const EmailNotificationModal: React.FC<EmailNotificationModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<
    "instantNotifications" | "periodicNotifications"
  >("instantNotifications");

  if (!isOpen) return null;

  const tabs = [
    { key: "instantNotifications", label: t("common.instantNotifications") },
    { key: "periodicNotifications", label: t("common.periodicNotifications") },
  ];

  return (
    <SettingsModalLayout
      isOpen={isOpen}
      onClose={onClose}
      icon={Bell}
      maxWidth="max-w-4xl"
      title={t("common.emailNotification")}
      containerClassName="mx-4"
      bodyClassName="p-0"
    >
      <div className="flex shrink-0 overflow-x-auto border-b">
        {tabs.map((tab) => (
          <div key={tab.key} className="flex shrink-0 items-center">
            <button
              type="button"
              className={`whitespace-nowrap px-6 py-3 font-medium transition-colors ${
                activeTab === tab.key
                  ? "border-b-2 border-blue-600 text-blue-600"
                  : "text-gray-600 hover:text-gray-800"
              }`}
              onClick={() => setActiveTab(tab.key as typeof activeTab)}
            >
              {tab.label}
            </button>
          </div>
        ))}
      </div>

      <div className="p-6">
        {activeTab === "instantNotifications" && (
          <InstantNotificationTab onClose={onClose} />
        )}
        {activeTab === "periodicNotifications" && (
          <PeriodicNotificationTab onClose={onClose} />
        )}
      </div>
    </SettingsModalLayout>
  );
};
